export default __webpack_public_path__ + "e86b021320cfaf779466c4d7f3a9bf1f.png";